import React, { useState } from 'react';

import { PiArrowRightBold } from "react-icons/pi";

import backWhite from "../../assets/backWhite.svg";
import Pagination from './Pagination/Pagination';

const CsvPreview = ({ file_name, values, tableRows, handleContinue, handleBack, setSkipDataValidation, skipDataValidation, showSkipValidation }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = values?.slice(indexOfFirstItem, indexOfLastItem);

  const handleContinueClick = () => {
    handleContinue();
  }

  const handleBackClick = () => {
    handleBack();
  }

  return (
    <>
      <div className='ps-7 border-l-[1px] border-[#CCCCCC]'>
        <div className="flex justify-between items-center mb-2">
          <span>Preview</span>
          <div className='flex gap-4 items-center'>
            {showSkipValidation && (
              <label className="text-gray-600 cursor-pointer text-sm">
                <input type="checkbox" className="mr-2 align-middle" checked={skipDataValidation} onChange={(e) => setSkipDataValidation(e.target.checked)} />
                <span className='align-middle'>Skip Data Validation</span>
              </label>
            )}
            <button
              className="flex items-center gap-2 bg-[#0078C5] px-2 py-1 hover:bg-[#00578F] text-white rounded-md text-sm"
              onClick={handleContinueClick}
            >
              <PiArrowRightBold color="#fff" size={15} />
              Continue
            </button>
            <button className="flex items-center gap-2 bg-[#BFBFBF] px-[10px] py-[5px] hover:bg-[#A5A5A5] back-btn text-white rounded-md text-sm"
              onClick={handleBackClick}
            >
              <img src={backWhite} alt="back" className='back-btn-img' />
              Go Back
            </button>
          </div>
        </div>
        <div className="mt-5 overflow-x-auto border-x-[1px] border-t-[1px] border-[#DDDEE0] rounded-t-lg">
          <h5 className="prepare_h5 px-4 py-3 text-sm bg-[#F9FAFB] text-[#212529] font-semibold border-b-[1px] border-[#DDDEE0]">
            File Name : {file_name}
          </h5>
          <table className="min-w-full table-fixed text-center text-sm font-light">
            <thead className="border-b font-medium border-[#DDDEE0]">
              <tr>
                {tableRows.map((rows, index) => {
                  return (
                    <th
                      key={index}
                      className="px-4 py-3 text-[#212529] font-semibold text-sm text-left"
                    >
                      {rows}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {currentItems.length === 0 ?
                <td colSpan={6} className="px-4 py-3 text-sm text-[#212529] font-normal">
                  There are no records to display.
                </td>
                :
                currentItems.map((value, index) => {
                  return (
                    <tr
                      key={index}
                      className="border-b font-normal text-sm border-[#DDDEE0]"
                    >
                      {/* <td>{index + 1}</td> */}
                      {value.map((val, i) => {
                        return (
                          <td
                            key={i}
                            className="px-4 py-3 w-44 h-[45px] break-all text-[0.88em] text-[#212529] text-left"
                          >
                            {val}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div >

      <Pagination
        data={values}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        indexOfFirstItem={indexOfFirstItem}
        indexOfLastItem={indexOfLastItem}
      />
    </>
  )
}

export default CsvPreview